export default {
    getAsideHeight: state => state.common.asideHeight,    // 页面高度
    getAsideWidth: state => state.common.asideWidth,    // 页面宽度
    getLoginInfo: state => state.common.loginInfo,    // 页面高度
}